import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { AddSmartSearchDialogComponent } from '@platform/smart-search/pages/add-smart-search-dialog/add-smart-search-dialog.component';
import { addSmartSearchSuccess } from '@shared/store/smart-searches/smart-searches.actions';
import { DialogService } from 'primeng/dynamicdialog';
import { take } from 'rxjs/operators';
import { WidgetHeaderComponent } from '../widget-header/widget-header.component';

@Component({
  selector: 'cp-widget-add-smart-search',
  imports: [CommonModule, WidgetHeaderComponent],
  templateUrl: './widget-add-smart-search.component.html',
  styleUrl: './widget-add-smart-search.component.scss',
})
export class WidgetAddSmartSearchComponent {
  private readonly dialogService = inject(DialogService);
  private readonly router = inject(Router);
  private readonly globalStore = inject(Store);
  muted = true;

  openSmartSearch(): void {
    const smartSearchFormDialogRef = this.dialogService.open(AddSmartSearchDialogComponent, {
      closable: false,
      closeOnEscape: true,
      transitionOptions: '0ms',
    });
    smartSearchFormDialogRef.onClose.pipe(take(1)).subscribe((smartSearch) => {
      if (smartSearch) {
        void this.router.navigate([paths.PLATFORM, paths.platform.SMART_SEARCH, smartSearch.id]);
        this.globalStore.dispatch(addSmartSearchSuccess({ smartSearch }));
      }
    });
  }
}
